<template>
  <form v-if="!currentAuthorizationToken" ref="form" @submit.prevent="login()">
    <v-text-field
      v-model="forgejoSite"
      label="forgejoSite"
      placeholder="forgejo site"
      required
      type="text"
    />
    <v-text-field
      v-model="username"
      label="username"
      placeholder="username"
      required
      type="text"
    />
    <v-text-field
      v-model="password"
      label="password"
      placeholder="password"
      required
      type="password"
    />
    <v-btn
      color="primary"
      :disabled="submitDisabled"
      type="submit"
      value="log in"
      >Login</v-btn
    >
  </form>
</template>
<script setup lang="ts">
import type { Ref } from "vue";
import { computed, ref } from "vue";
import {
  currentAuthorizationToken,
  setAuthorizationToken,
} from "../authenticationTokens";
import { userCreateToken, userGetCurrent } from "../gen/forgejo-vue";

const forgejoSite: Ref<string> = ref("");
const username = ref("");
const password = ref("");
const submitDisabled = computed(() => {
  return !(forgejoSite.value && username.value && password.value);
});

async function login() {
  if (submitDisabled.value) {
    return;
  }
  const authorization = "Basic " + btoa(`${username.value}:${password.value}`);
  // create a string to make the token name unique
  const dateSuffix = new Date()
    .toISOString()
    .slice(0, 19)
    .replace(":", "-")
    .replace(":", "-");
  const options = {
    baseURL: forgejoSite.value + "/api/v1/",
    headers: { Authorization: authorization },
  };
  const token = await userCreateToken(
    username.value,
    {
      name: `todomvp-${dateSuffix}`,
      scopes: [
        "read:user",
        "read:repository",
        "write:repository",
        "read:issue",
        "write:issue",
      ],
    },
    options,
  );
  if (token.status !== 201) {
    return;
  }
  const { name, sha1 } = token.data;
  const r = await userGetCurrent(options);
  if (r.status !== 200) {
    return;
  }
  if (name && sha1 && r.data.id) {
    setAuthorizationToken({
      server: forgejoSite.value,
      token_name: name,
      token: sha1,
      username: username.value,
      uid: r.data.id,
    });
  }
}
</script>
